/* import __COLOCATED_TEMPLATE__ from './awaiting-end-user-reply.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();